var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJustParkLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#justParkLocationPin_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.334 41.928c.201-.43.595-.736 1.057-.85C38.21 39.138 44 32.14 44 23.805 44 13.972 35.941 6 26 6S8 13.972 8 23.805c0 7.92 5.227 14.633 12.455 16.945.418.134.769.427.954.824l2.686 5.757c.539 1.154 2.18 1.154 2.719 0l2.52-5.403z",
    className: "justParkLocationPin_svg__pin-body"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.662 31.214c0 1.713-1.406 3.102-3.142 3.102-.588 0-1.064-.47-1.064-1.05h-.001V20.69c0-4.13 3.3-7.606 7.482-7.688 4.29-.085 7.795 3.323 7.795 7.539 0 3.897-2.997 7.099-6.839 7.494a.165.165 0 00-.15.163v.953c0 .33-.372.493-.585.255l-2.592-2.9a.784.784 0 010-1.018l2.592-2.9c.213-.237.584-.075.584.255v.94c0 .113.11.193.22.164 1.474-.38 2.562-1.701 2.562-3.275 0-1.921-1.62-3.469-3.586-3.383-1.852.08-3.276 1.66-3.276 3.49v10.435z",
    className: "justParkLocationPin_svg__logo"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "justParkLocationPin_svg__a",
    x: 0,
    y: 0,
    width: 52,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4265_9251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4265_9251",
    result: "effect2_dropShadow_4265_9251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4265_9251",
    result: "shape"
  })))));
}
export default SvgJustParkLocationPin;